import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { VerifyOtpRouteComponent } from "./-components/route";

export const Route = createFileRoute(
  "/auth/_auth-layout/verify-otp/$otpRequestId",
)({
  component: VerifyOtpRouteComponent,
  validateSearch: zodValidator(
    z.object({
      afterSignInUrl: z.string().optional(),
    }),
  ),
});
